import { RoomTypes } from '@weblite/ts-action/room'
import { getPv } from '$logic/pv'
import { getUser, getUserFirstName } from '$logic/users'
import { getImageUrl } from '$func/imageUrl'
import { getHall } from '$logic/hall'
import { getWappRoom } from '$logic/wapp-room'
import { getWapp } from '$logic/wapps/service'
import { t } from '$i18n'

export const getRoomImageAndName = async (
  roomType: RoomTypes,
  roomId: string,
) => {
  if (roomType === 'PV') {
    const pv = await getPv(roomId)
    const userId = pv?.to
    const user = await getUser(userId)
    return {
      image: getImageUrl(user?.image),
      name: getUserFirstName(user),
      user,
    }
  }

  if (roomType === 'CHANNEL' || roomType === 'GROUP') {
    const hall = await getHall(roomId)
    return { image: getImageUrl(hall?.image), name: hall?.name, hall }
  }

  if (roomType === 'WAPP_ROOM') {
    const wappRoom = await getWappRoom(roomId)
    const { wappId } = wappRoom || {}
    const wapp = await getWapp(wappId)
    return { image: getImageUrl(wapp?.image), name: wapp?.name, wappRoom }
  }

  if (roomType === 'PRIVATE_SPACE')
    return {
      name: t('chatList.privateSpace'),
      image: 'assets/svg/private-space.svg',
    }

  return {}
}
